<script>
import { utilizeFunction, utilizeMenuMobile, toggleSearch } from './../../../static/js/main_vue.js';
import { app, Account ,ShoppingCart, Location} from './../../functions.js';

import AccountAPI from './../../api/account.js';
import ProductAPI from './../../api/product.js';

import LocationModal from './LocationModal.vue';
import ConfirmDialogue from './ConfirmDialogue.vue';
import AlertDialogue from './AlertDialogue.vue';

export default {
  name: 'HeaderThree',
  components: {
    LocationModal,
    ConfirmDialogue,
    AlertDialogue
  },
  data () {
    return {
      app,
      Account,
      Location,
      ShoppingCart,
      search_query: '',
      showLocationModal: false
    }
  },
  methods: {
      removeFromCart(product, index)
       {
           // Assign 0 quantity for product to be removed from cart
           var x = ShoppingCart.removeFromCart(product, 0);
           x.then((response)=>{
               console.log(response);
           });
       },
    setLocation (location) {
      this.showLocationModal = false;
    window.location.reload();
    },
    search (event) {
      event.preventDefault();
      if(this.search_query != '')
      {
          try{
              var savekeyword_request = ProductAPI.saveSearchKeyword(this.search_query);
              savekeyword_request.then((response)=>{
                  this.$router.push({ name: 'shop', query: { q: this.search_query } });
              });
          } catch(error) {
              this.$router.push({ name: 'shop', query: { q: this.search_query } });
          };
      }
    },
    async signOut()
    {
          var is_temp_password = Account.getPasswordStatus();
       if(is_temp_password)
       {
          this.$refs.alertDialogue.show({
               title: "Update your Password",
              message: "Please change your password first before signing out",
              okButton: 'OK',
              buttonLayout: 'not-block'
          });
       }
       else {
        var do_logout = await this.$refs.confirmDialogue.show({
              title: "Are you sure you want to Sign out?",
              message: " ",
              okButton: 'Yes',
              cancelButton: 'No',
              buttonLayout: 'not-block'
          });

         if(do_logout) {
                var login_id = this.Account.getLoginId();
                var token = this.Account.getToken();

                if(!login_id || !token)
                {
                    // Clear Session
                    this.Account.setLoginId('');
                    this.Account.setToken('');

                      this.Account.setCustomerID('');
                      this.Account.setAddresses([]);
                    // this.ShoppingCart.active_shopping_cart = 0;
                    // this.ShoppingCart.cart = this.ShoppingCart.EMPTY_CART;
                }
                else
                {
                    var logout_request = AccountAPI.logout(token)
                    logout_request.then((response)=>{
                      this.Account.setToken('');
                      this.Account.setLoginId('');
                      
                      this.Account.setCustomerID('');
                      
                      this.Account.setAddresses([]);
                      // this.ShoppingCart.active_shopping_cart = 0;
                      // this.ShoppingCart.cart = this.ShoppingCart.EMPTY_CART;
                      this.$router.push({ name: "login", query: { 'm' :"user_logout"}})
                    });
                }
            }
        }
    },
     getProductPrice(product)
    {
      if(product.product.sale_type == 'default')
      {
        return (product.product.product_price * product.quantity);
      }
      else
      {
     
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }


             if(has_price_off_promo)
             {
              return (product.product.sale_price * product.quantity)
              
            }
            else
            {
                return (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price * product.quantity) : (product.product.product_sale_price * product.quantity));
                
            }

      }
      


      // if(product.product.sale_type == 'fixed' || product.product.sale_type == 'percentage' || product.product.sale_type == 'promo')
      // {
      //   if(product.product.sale_type == 'promo')
      //   {

      //       var has_price_off_promo = false;
      //       var price_off_promo_index = 0;
 
      //       if(product.product.promo)
      //       {
      //         product.product.promo.forEach((promo, promo_index)=>{
      //           if(typeof promo == 'object' && !Array.isArray(promo)) {
      //             if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //             {
                   
      //                var passed_product_requirements = 0;
      //              promo.required_items.forEach((ri,ri_index)=>{
      //                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //                 if(p.product.sku == ri.sku_id)
      //                 {
      //                   passed_product_requirements+=1;
      //                 }
      //               });
      //             });

      //               if(passed_product_requirements == promo.required_items.length)
      //             {
                    
      //                 if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
      //                 {

      //                   if(has_price_off_promo)
      //                   {

      //                     if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
      //                     {
      //                       price_off_promo_index = promo_index;
      //                           has_price_off_promo = true;
      //                     }

      //                   }
      //                   else
      //                   {

      //                      price_off_promo_index = promo_index;
      //                        has_price_off_promo = true;
      //                     }
      //                 }
                 
      //             }

      //             }
      //           }
      //         });
      //       }

      //        if(has_price_off_promo)
      //        {
      //         return (product.product.promo[price_off_promo_index].promo_selling_price * product.quantity)
              
      //       }
      //       else
      //       {

      //           return (product.product.product_price * product.quantity);
      //       }

      //   }
      //   else
      //   {
      //     return (product.product.sale_price * product.quantity);
      //   }

      // }
      // else
      // {
      //   return (product.product.product_price * product.quantity);
      // }

    },
    getProductPromoDescription(product)
    {
      if(product.product.sale_type == 'default')
      {
        return '';
      }
      else
      {
      
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
 
            if(product.product.promo)
            {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo)) {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                   
                     var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }

                  }
                }
              });
            }

             if(has_price_off_promo)
             {
              return (product.product.promo[price_off_promo_index].promo_description)
              
            }
            else
            {

                return '';
            }

      

      }

    },

    hasProductPromo(product)
    {

      if(product.product.sale_type == 'promo' && product.product.promo)
      {
        if(product.product.sale_type == 'promo')
        {

            var has_applicable_promo = false;
            var applicable_promo_index = 0;
            product.product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)) {
              if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT' || (promo.promo_type).toUpperCase() == 'FREE GIFT')
              {
                var passed_product_requirements = 0;
                promo.required_items.forEach((ri,ri_index)=>{
                   ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                    if(p.product.sku == ri.sku_id)
                    {
                      passed_product_requirements+=1;
                    }
                  });
                });

                if(passed_product_requirements == promo.required_items.length)
                {
                
                   if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                  {

                      applicable_promo_index = promo_index;
                    has_applicable_promo = true;
                  }
                }
              }
            }
            });

            
           if(has_applicable_promo)
           {
             return true;
           }
           else
           {
             return null;
           }

        }
        else
        {
          return null;
        }

      }
    

    },

    getProductSlashedPrice(product)
    {

       if(product.product.sale_type == 'default')
      {
        return (0);
      }
      else
      {
       
            var has_price_off_promo = false;
            var price_off_promo_index = 0;
            if(product.product.promo) {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo))
                {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                  {
                
                      var passed_product_requirements = 0;
                   promo.required_items.forEach((ri,ri_index)=>{
                     ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                      if(p.product.sku == ri.sku_id)
                      {
                        passed_product_requirements+=1;
                      }
                    });
                  });

                    if(passed_product_requirements == promo.required_items.length)
                  {
                    
                      if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
                      {

                        if(has_price_off_promo)
                        {

                          if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                          {
                            price_off_promo_index = promo_index;
                                has_price_off_promo = true;
                          }

                        }
                        else
                        {

                           price_off_promo_index = promo_index;
                             has_price_off_promo = true;
                          }
                      }
                 
                  }
                  }
                }
              });
            }


          if(has_price_off_promo)
          { 
            return (product.product.original_price * product.quantity);   
          }
          else
          {
           return (product.product.product_price == parseFloat(product.product.product_sale_price) ? 0 : (product.product.original_price * product.quantity));
          }

     

      }
     

      // if(product.product.sale_type == 'fixed' || product.product.sale_type == 'percentage' || product.product.sale_type == 'promo')
      // {
      //   if(product.product.sale_type == 'promo')
      //   {
      //       var has_price_off_promo = false;
      //       var price_off_promo_index = 0;
      //       if(product.product.promo) {
      //         product.product.promo.forEach((promo, promo_index)=>{
      //           if(typeof promo == 'object' && !Array.isArray(promo))
      //           {
      //             if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //             {
                
      //                 var passed_product_requirements = 0;
      //              promo.required_items.forEach((ri,ri_index)=>{
      //                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //                 if(p.product.sku == ri.sku_id)
      //                 {
      //                   passed_product_requirements+=1;
      //                 }
      //               });
      //             });

      //               if(passed_product_requirements == promo.required_items.length)
      //             {
                    
      //                 if(promo.promo_minimum_amount <= ShoppingCart.getCartTotal(0))
      //                 {

      //                   if(has_price_off_promo)
      //                   {

      //                     if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
      //                     {
      //                       price_off_promo_index = promo_index;
      //                           has_price_off_promo = true;
      //                     }

      //                   }
      //                   else
      //                   {

      //                      price_off_promo_index = promo_index;
      //                        has_price_off_promo = true;
      //                     }
      //                 }
                 
      //             }
      //             }
      //           }
      //         });
      //       }


      //       if(has_price_off_promo)
      //       {

             
      //               return (product.product.original_price * product.quantity);
               
              
      //     }
      //     else
      //     {
      //       return 0;
      //     }

      //   }
      //   else
      //   {
      //     return (product.product.original_price * product.quantity);
      //   }

      // }
      // else
      // {
      //   return (0);
      // }
    }
  },
  mounted () {
      utilizeFunction();
      utilizeMenuMobile();
      toggleSearch();
  }
}
</script>

<template>
    <div>
    <!-- HEADER AREA START (header-3) -->
    <LocationModal v-if="showLocationModal" @onClose="showLocationModal = false" @onSelectLocation="setLocation" />

    <header class="ltn__header-area ltn__header-3 section-bg-6">
        <!-- ltn__header-top-area start -->

        <div class="ltn__header-top-area">
            <!-- New Top Area Start-->
            <div class="container free" v-if="1 == 0">
                <h5>FREE DELIVERY ON ORDERS OVER ₱5,000</h5>
            </div>
            <!-- New Top Area End -->

            <!-- Old Top Area Start-->
            <div class="container">   <!-- Just Remove v-if condition -->
                <div class="row">
                    <div class="col-md-7">
                        <div class="ltn__top-bar-menu ">
                            <ul>
                                <li><a class="link-3" href="mailto:customercare@sanmiguel.com.ph"><i class="icon-mail secondary-color"></i> customercare@sanmiguel.com.ph</a></li>
                                <li class="black-color" @click="showLocationModal = true "><i class="icon-placeholder secondary-color"></i> {{ Location.location ? (Location.location.barangay.brgy_name + ', ' + Location.location.city.city_name) : 'Select Location' }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="top-bar-right text-right">
                            <div class="ltn__top-bar-menu">

                                <ul>
                                   <!--  <li>
                                       
                                        <div class="ltn__drop-menu ltn__currency-menu ltn__language-menu">
                                            <ul>
                                                <li><a class="dropdown-toggle"><span class="active-currency">{{app.active_currency.code}}</span></a>
                                                    <ul>
                                                        <li v-for="currency in app.currency_list" v-if="currency.active" @click="app.setActiveCurrency(currency)">{{ currency.name }}</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </li> -->
                                    <li>
                                        <!-- ltn__social-media -->
                                        <div class="ltn__social-media ">
                                            <ul>
                                                <li><a class="social-media" href="https://www.facebook.com/greatfoodsolutions" target="_blank" title="Great Foods Solution"><i class="fab fa-facebook-f"></i></a></li>
                                              <!--   <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>

                                                <li><a href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li> -->
                                                <li><a class="social-media" href="https://www.youtube.com/@HomeFoodiePH/videos" target="_blank" title="Home Foodie"><i class="fab fa-youtube"></i></a></li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Old Top Area End-->
        </div>
        <!-- ltn__header-top-area end -->
        <!-- ltn__header-middle-area start -->
        <div class="ltn__header-middle-area-1 ltn__header-middle-area">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="site-logo">
                            <router-link to="/"><img src="/static/img/newlogo.png" alt="Logo"></router-link>
                        </div>
                    </div>
                    <d  iv class="col header-contact-serarch-column d-none d-lg-block">
                        <div class="header-contact-search">
                            <!-- header-feature-item -->
                            <div class="header-feature-item">
                                <div class="header-feature-icon">
                                    <i class="icon-call"></i>
                                </div>
                                <div class="header-feature-info">
                                    <h6>Phone</h6>
                                    <p><a class="link" href="tel:(+632) 5317-5000">(+632) 5317-5000</a></p>
                                </div>
                            </div>
                            <!-- header-search-2 -->
                            <div class="header-search-2">
                                <form >
                                    <input type="text" name="search" value="" placeholder="Search here..." v-model="search_query"/>
                                    <button type="submit" @click="search">
                                        <span><i class="icon-search"></i></span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </d>
                    <div class="col">
                        <!-- header-options -->
                        <div class="ltn__header-options">
                            <ul>
                                <li class="d-none">
                                    <!-- ltn__currency-menu -->
                                    <div class="ltn__drop-menu ltn__currency-menu">
                                        <ul>
                                            <li><a href="#" class="dropdown-toggle"><span class="active-currency">USD</span></a>
                                                <ul>
                                                    <li><router-link to="/login">USD - US Dollar</router-link></li>
                                                    <li><router-link to="/wishlist">CAD - Canada Dollar</router-link></li>
                                                    <li><router-link to="/register">EUR - Euro</router-link></li>
                                                    <li><router-link to="/account">GBP - British Pound</router-link></li>
                                                    <li><router-link to="/wishlist">INR - Indian Rupee</router-link></li>
                                                    <li><router-link to="/wishlist">BDT - Bangladesh Taka</router-link></li>
                                                    <li><router-link to="/wishlist">JPY - Japan Yen</router-link></li>
                                                    <li><router-link to="/wishlist">AUD - Australian Dollar</router-link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="d-lg-none">
                                    <!-- header-search-1 -->
                                    <div class="header-search-wrap">
                                        <div class="header-search-1">
                                            <div class="search-icon">
                                                <i class="icon-search  for-search-show"></i>
                                                <i class="icon-cancel  for-search-close"></i>
                                            </div>
                                        </div>
                                        <div class="header-search-1-form">
                                            <form v-on:submit="search">
                                                <input type="text" name="search" value="" placeholder="Search here..." v-model="search_query"/>
                                                <button type="submit">
                                                    <span><i class="icon-search"></i></span>
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </li>
                                <li class="d-none---">
                                    <!-- user-menu -->
                                    <div class="ltn__drop-menu user-menu ">
                                        <ul>
                                            <li class="">
                                                <a><i class="icon-user "></i></a>
                                                <ul class="">
                                                     <router-link to="/login" v-if="!Account.auth.token" tag="li">Sign In</router-link>
                                                    <li @click="signOut" v-if="Account.auth.token">Sign Out</li>
                                                    <router-link to="/register" tag="li" v-if="!Account.auth.token">Register</router-link>
                                                   <router-link to="/account" tag="li" v-if="Account.auth.token" >My Account</router-link>
                                                    <!-- <li v-if="Account.auth.token"><router-link to="/wishlist" >Wish List</router-link></li> -->

                                               
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <!-- mini-cart 2 -->
                                    <div class="mini-cart-icon mini-cart-icon-2">
                                        <a href="#ltn__utilize-cart-menu" class="ltn__utilize-toggle">
                                            <span class="mini-cart-icon ">
                                                <i class="icon-shopping-cart"></i>
                                                <sup>{{ ShoppingCart.getTotalCartItems() }}</sup>
                                            </span>
                                            <h6><span>Your Cart</span> <span class="secondary-color">{{ ShoppingCart.getCartTotal() | currencyFormat }}</span></h6>
                                        </a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ltn__header-middle-area end -->
        <!-- header-bottom-area start -->
        <div class="header-bottom-area ltn__border-top ltn__header-sticky  ltn__sticky-bg-black--- ltn__sticky-bg-secondary  menu-color-black d-none d-lg-block">
            <div class="container">
                <div class="row">
                    <div class="col header-menu-column justify-content-center ">
                        <div class="sticky-logo">
                            <div class="site-logo">
                                <router-link to="/"><img src="/static/img/logo-alt.png" alt="Logo"></router-link>
                            </div>
                        </div>
                        <div class="header-menu header-menu-2">
                            <nav>
                                <div class="ltn__main-menu color-black">
                                    <ul>
                                        <li><router-link to="/">Home</router-link></li>
                                        <li><router-link to="/about">About</router-link>
                                            <ul>
                                                <li><router-link to="/about">About</router-link></li>
                                                <li><router-link to="/faq">FAQ</router-link></li>
                                            </ul>
                                        </li>
                                        <li><router-link to="/shop">Shop</router-link>
                                            <!-- <ul>
                                                <li><router-link to="/shop">Shop</router-link></li>
                                                <li><router-link to="/shop-grid">Shop Grid</router-link></li>
                                                <li><router-link to="/shop-left-sidebar">Shop Left sidebar</router-link></li>
                                                <li><router-link to="/shop-right-sidebar">Shop right sidebar</router-link></li>
                                                <li><router-link to="/product-details">Shop details </router-link></li>
                                                <li><router-link to="/product-details-no-sidebar">Shop details no sidebar </router-link></li>
                                                <li><a href="#">Other Pages <span class="float-right">>></span></a>
                                                    <ul>
                                                        <li><router-link to="/cart">Cart</router-link></li>
                                                        <li><router-link to="/wishlist">Wishlist</router-link></li>
                                                        <li><router-link to="/checkout">Checkout</router-link></li>
                                                        <li><router-link to="/order-tracking">Order Tracking</router-link></li>
                                                        <li><router-link to="/account">My Account</router-link></li>
                                                        <li><router-link to="/login">Sign in</router-link></li>
                                                        <li><router-link to="/register">Register</router-link></li>
                                                    </ul>
                                                </li>
                                            </ul> -->
                                        </li>
                                       <!--  <li class="menu-icon"><router-link to="/blog">News</router-link>
                                            <ul>
                                                <li><router-link to="/blog">News</router-link></li>
                                                <li><router-link to="/blog-grid">News Grid</router-link></li>
                                                <li><router-link to="/blog-left-sidebar">News Left sidebar</router-link></li>
                                                <li><router-link to="/blog-right-sidebar">News Right sidebar</router-link></li>
                                                <li><router-link to="/blog-details">News details</router-link></li>
                                            </ul>
                                        </li>
                                        <li class="menu-icon"><a href="#">Pages</a>
                                            <ul class="mega-menu">
                                                <li><a href="#">Inner Pages</a>
                                                    <ul>
                                                        <li><router-link to="/portfolio">Gallery</router-link></li>
                                                        <li><router-link to="/portfolio-alt">Gallery - 02</router-link></li>
                                                        <li><router-link to="/portfolio-details">Gallery Details</router-link></li>
                                                        <li><router-link to="/team">Team</router-link></li>
                                                        <li><router-link to="/team-details">Team Details</router-link></li>
                                                        <li><router-link to="/faq">FAQ</router-link></li>
                                                    </ul>
                                                </li>
                                                <li><a href="#">Inner Pages</a>
                                                    <ul>
                                                        <li><router-link to="/history">History</router-link></li>
                                                        <li><router-link to="/contact">Appointment</router-link></li>
                                                        <li><router-link to="/locations">Google Map Locations</router-link></li>
                                                        <li><router-link to="/page-not-found">404</router-link></li>
                                                        <li><router-link to="/contact">Contact</router-link></li>
                                                        <li><router-link to="/coming-soon">Coming Soon</router-link></li>
                                                    </ul>
                                                </li>
                                                <li><a href="#">Shop Pages</a>
                                                    <ul>
                                                        <li><router-link to="/shop">Shop</router-link></li>
                                                        <li><router-link to="/shop-left-sidebar">Shop Left sidebar</router-link></li>
                                                        <li><router-link to="/shop-right-sidebar">Shop right sidebar</router-link></li>
                                                        <li><router-link to="/shop-grid">Shop Grid</router-link></li>
                                                        <li><router-link to="/product-details">Shop details </router-link></li>
                                                        <li><router-link to="/cart">Cart</router-link></li>
                                                    </ul>
                                                </li>
                                                <li><router-link to="/shop"><img src="/static/img/banner/menu-banner-1.png" alt="#"></router-link>
                                                </li>
                                            </ul>
                                        </li> -->
                                        <li><router-link to="/contact">Contact</router-link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                     <div class="ltn__header-options ltn__header-options-2">
                            <!-- header-search-1 -->
                            <div class="header-search-wrap">
                                <div class="header-search-1">
                                    <div class="search-icon">
                                        <i class="icon-search for-search-show"></i>
                                        <i class="icon-cancel  for-search-close"></i>
                                    </div>
                                </div>
                                <div class="header-search-1-form">
                                    <form v-on:submit="search">
                                        <input type="text" name="search" v-model="search_query" placeholder="Search here..."/>
                                        <button type="submit">
                                            <span><i class="icon-search"></i></span>
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <!-- user-menu -->
                            <div class="ltn__drop-menu user-menu">
                                <ul>
                                    <li>
                                        <a><i class="icon-user"></i></a>
                                         <ul>
                                           <!--  <li v-if="!Account.auth.token"><router-link to="/login">Sign In</router-link></li>
                                            <li v-if="Account.auth.token"><a @click="signOut">Sign Out</a></li>
                                            <li v-if="!Account.auth.token"><router-link to="/register">Register</router-link></li>
                                            <li v-if="Account.auth.token"><router-link to="/account"  >My Account</router-link></li>
                                            <li v-if="Account.auth.token"><router-link to="/wishlist" >Wish List</router-link></li> -->

                                                 <router-link to="/login" v-if="!Account.auth.token" tag="li">Sign In</router-link>
                                                    <li @click="signOut" v-if="Account.auth.token">Sign Out</li>
                                                    <router-link to="/register" tag="li" v-if="!Account.auth.token">Register</router-link>
                                                   <router-link to="/account" tag="li" v-if="Account.auth.token" >My Account</router-link>
                                                   <!-- <router-link to="/account" tag="li" v-if="Account.auth.token">Wish List</router-link> -->
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <!-- mini-cart -->
                            <div class="mini-cart-icon">
                                <a href="#ltn__utilize-cart-menu" class="ltn__utilize-toggle">
                                    <i class="icon-shopping-cart"></i>
                                    <sup v-if="ShoppingCart.getTotalCartItems() > 0">{{ ShoppingCart.getTotalCartItems() }}</sup>
                                </a>
                            </div>
                            <!-- mini-cart -->
                            <!-- Mobile Menu Button -->
                            <div class="mobile-menu-toggle d-lg-none">
                                <a href="#ltn__utilize-mobile-menu" class="ltn__utilize-toggle">
                                    <svg viewBox="0 0 800 600">
                                        <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top"></path>
                                        <path d="M300,320 L540,320" id="middle"></path>
                                        <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <!-- header-bottom-area end -->
    </header>
    <!-- HEADER AREA END -->

    <!-- Utilize Cart Menu Start -->
    <div id="ltn__utilize-cart-menu" class="ltn__utilize ltn__utilize-cart-menu">
        <div class="ltn__utilize-menu-inner ltn__scrollbar">
            <div class="ltn__utilize-menu-head">
                <span class="ltn__utilize-menu-title">Cart</span>
                <button class="ltn__utilize-close">×</button>
            </div>
            <div class="mini-cart-product-area ltn__scrollbar" v-for="cartGroup in ShoppingCart.cart">
                <div class="mini-cart-item clearfix" v-for="product in cartGroup.products">
                    <div class="mini-cart-img">
                        <router-link :to="{ name: 'productDetails', params: { sku_id: product.product.sku, sku_name: product.product.product_name }}"><img :src="product.product.product_image[0]" alt="Image"></router-link>
                        <span class="mini-cart-item-delete" @click="removeFromCart(product.product)"><i class="icon-cancel"></i></span>
                    </div>
                    <div class="mini-cart-info">
                    
                        <h6><router-link :to="{ name: 'productDetails', params: { sku_id: product.product.sku, sku_name: product.product.product_name }}">{{ product.product.product_name }}</router-link></h6>
                         <span class="mini-cart-quantity">{{ product.quantity }} x {{ getProductPrice(product) | currencyFormat }} 
                            <del v-if="getProductSlashedPrice(product) > 0">{{ getProductSlashedPrice(product) | currencyFormat }}</del>
                            </span>
                            <div class="promo-details text-left" v-if="hasProductPromo(product)">
                                <small>
                                   <div>{{  getProductPromoDescription(product) }}</div>
                                   </small>
                             </div>
                    </div>
                </div>
            </div>
            <div class="mini-cart-footer">
               <!--  <div class="mini-cart-sub-total">
                    <h5>Cart Weight: <span>{{ ShoppingCart.getTotalCartWeight() / 1000 }} kg</span></h5>
                </div>
                <div class="mini-cart-sub-total">
                    <h5>Weight Limit: <span>{{ ShoppingCart.getCartWeightLimit() / 1000 }} kg</span></h5>
                </div> -->
                <div class="mini-cart-sub-total">
                    <h5>Subtotal: <span class="secondary-color">{{ ShoppingCart.getCartTotal() | currencyFormat }}</span></h5>
                </div>
                <div class="btn-wrapper">
                    <router-link to="/cart" class="theme-btn-1  btn btn-effect-1 ltn__utilize-close">View Cart</router-link>
                    <router-link to="/checkout" class="theme-btn-2  btn  btn-effect-2 ltn__utilize-close">Checkout</router-link>
                </div>
            </div>

        </div>
    </div>
    <!-- Utilize Cart Menu End -->

    <!-- Utilize Mobile Menu Start -->
    <div id="ltn__utilize-mobile-menu" class="ltn__utilize ltn__utilize-mobile-menu">
        <div class="ltn__utilize-menu-inner ltn__scrollbar">
            <div class="ltn__utilize-menu-head">
                <div class="site-logo">
                    <router-link to="/"><img src="/static/img/logo.png" alt="Logo"></router-link>
                </div>
                <button class="ltn__utilize-close">×</button>
            </div>
            <div class="ltn__utilize-menu-search-form">
                <form action="#">
                    <input type="text" v-model="search_query" placeholder="Search...">
                    <button @click="search"><i class="fas fa-search"></i></button>
                </form>
            </div>
            <div class="ltn__utilize-menu">
                <ul>
                    <li><router-link to="/">Home</router-link>
                     <!--    <ul class="sub-menu">
                            <li><router-link to="/">Home Pages 01</router-link></li>
                        </ul> -->
                    </li>
                    <li><a>About</a>
                        <ul class="sub-menu">
                            <li><router-link to="/about">About</router-link></li>
                            <li><router-link to="/faq">FAQ</router-link></li>
                        </ul>
                    </li>
                    <li><router-link to="/shop">Shop</router-link>
                      <!--   <ul class="sub-menu">
                            <li><router-link to="/shop">Shop</router-link></li>
                            <li><router-link to="/shop-grid">Shop Grid</router-link></li>
                            <li><router-link to="/shop-left-sidebar">Shop Left sidebar</router-link></li>
                            <li><router-link to="/shop-right-sidebar">Shop right sidebar</router-link></li>
                            <li><router-link to="/product-details">Shop details </router-link></li>
                            <li><router-link to="/cart">Cart</router-link></li>
                            <li><router-link to="/wishlist">Wishlist</router-link></li>
                            <li><router-link to="/checkout">Checkout</router-link></li>
                            <li><router-link to="/order-tracking">Order Tracking</router-link></li>
                            <li><router-link to="/account">My Account</router-link></li>
                            <li><router-link to="/login">Sign in</router-link></li>
                            <li><router-link to="/register">Register</router-link></li>
                        </ul> -->
                    </li>
                    <!-- <li><router-link to="/blog">News</router-link>
                        <ul class="sub-menu">
                            <li><router-link to="/blog">News</router-link></li>
                            <li><router-link to="/blog-grid">News Grid</router-link></li>
                            <li><router-link to="/blog-left-sidebar">News Left sidebar</router-link></li>
                            <li><router-link to="/blog-right-sidebar">News Right sidebar</router-link></li>
                            <li><router-link to="/blog-details">News details</router-link></li>
                        </ul>
                    </li>
                    <li><a href="#">Pages</a>
                        <ul class="sub-menu">
                            <li><router-link to="/about">About</router-link></li>
                            <li><router-link to="/service">Services</router-link></li>
                            <li><router-link to="/service-details">Service Details</router-link></li>
                            <li><router-link to="/portfolio">Portfolio</router-link></li>
                            <li><router-link to="/portfolio-alt">Portfolio - 02</router-link></li>
                            <li><router-link to="/portfolio-details">Portfolio Details</router-link></li>
                            <li><router-link to="/team">Team</router-link></li>
                            <li><router-link to="/team-details">Team Details</router-link></li>
                            <li><router-link to="/faq">FAQ</router-link></li>
                            <li><router-link to="/history">History</router-link></li>
                            <li><router-link to="/blog">Appointment</router-link></li>
                            <li><router-link to="/locations">Google Map Locations</router-link></li>
                            <li><router-link to="/page-not-found">404</router-link></li>
                            <li><router-link to="/contact">Contact</router-link></li>
                            <li><router-link to="/coming-soon">Coming Soon</router-link></li>
                        </ul>
                    </li> -->
                    <li><router-link to="/contact">Contact</router-link></li>
                </ul>
            </div>
            <div class="ltn__utilize-buttons ltn__utilize-buttons-2">
                <ul>
                    <li>
                        <router-link to="/account" title="My Account">
                            <span class="utilize-btn-icon">
                                <i class="far fa-user"></i>
                            </span>
                            My Account
                        </router-link>
                    </li>
                   <!--  <li>
                        <a href="wishlist.html" title="Wishlist">
                            <span class="utilize-btn-icon">
                                <i class="far fa-heart"></i>
                                <sup>3</sup>
                            </span>
                            Wishlist
                        </a>
                    </li> -->
                    <li>
                        <router-link to="/cart" title="Shoping Cart">
                            <span class="utilize-btn-icon">
                                <i class="fas fa-shopping-cart"></i>
                                <sup>5</sup>
                            </span>
                            Shoping Cart
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="ltn__social-media-2">
                <ul>
                    <li><a href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                    <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                    <li><a href="#" title="Linkedin"><i class="fab fa-linkedin"></i></a></li>
                    <li><a href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Utilize Mobile Menu End -->

    <div class="ltn__utilize-overlay"></div>

       <ConfirmDialogue ref="confirmDialogue" />
        <AlertDialogue ref="alertDialogue" />
    <div class="mobile-header-menu-fullwidth">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- Mobile Menu Button -->
                    <div class="mobile-menu-toggle d-lg-none">
                        <span>MENU</span>
                        <a href="#ltn__utilize-mobile-menu" class="ltn__utilize-toggle">
                            <svg viewBox="0 0 800 600">
                                <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top"></path>
                                <path d="M300,320 L540,320" id="middle"></path>
                                <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style>
.header-bottom-area.ltn__border-top.ltn__header-sticky.ltn__sticky-bg-black---.ltn__sticky-bg-secondary.ltn__secondary-bg.section-bg-1.menu-color-white.d-none.d-lg-block:not(.sticky-active) .ltn__header-options-2 {
    display: none;
}
.mini-cart-icon sup {
    font-size: 12px;
    font-weight: 600;
}
.ltn__main-menu ul li a {
    font-size: 22px;
}
.link-3 {
  color: var(--black-color) !important;
}

.link-3:hover {
  color: var(--secondary-color) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HeaderThree.vue